import { bisector, tickStep } from "d3-array";
import { durationDay, durationHour, durationMinute, durationMonth, durationSecond, durationWeek, durationYear } from "./duration.js";
import millisecond from "./millisecond.js";
import second from "./second.js";
import minute from "./minute.js";
import hour from "./hour.js";
import day from "./day.js";
import { sunday as week } from "./week.js";
import month from "./month.js";
import year from "./year.js";
import utcMinute from "./utcMinute.js";
import utcHour from "./utcHour.js";
import utcDay from "./utcDay.js";
import { utcSunday as utcWeek } from "./utcWeek.js";
import utcMonth from "./utcMonth.js";
import utcYear from "./utcYear.js";
function ticker(year, month, week, day, hour, minute) {
    var tickIntervals = [
        [second, 1, durationSecond],
        [second, 5, 5 * durationSecond],
        [second, 15, 15 * durationSecond],
        [second, 30, 30 * durationSecond],
        [minute, 1, durationMinute],
        [minute, 5, 5 * durationMinute],
        [minute, 15, 15 * durationMinute],
        [minute, 30, 30 * durationMinute],
        [hour, 1, durationHour],
        [hour, 3, 3 * durationHour],
        [hour, 6, 6 * durationHour],
        [hour, 12, 12 * durationHour],
        [day, 1, durationDay],
        [day, 2, 2 * durationDay],
        [week, 1, durationWeek],
        [month, 1, durationMonth],
        [month, 3, 3 * durationMonth],
        [year, 1, durationYear]
    ];
    function ticks(start, stop, count) {
        var _a;
        var reverse = stop < start;
        if (reverse)
            _a = [stop, start], start = _a[0], stop = _a[1];
        var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        var ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        var target = Math.abs(stop - start) / count;
        var i = bisector(function (_a) {
            var step = _a[2];
            return step;
        }).right(tickIntervals, target);
        if (i === tickIntervals.length)
            return year.every(tickStep(start / durationYear, stop / durationYear, count));
        if (i === 0)
            return millisecond.every(Math.max(tickStep(start, stop, count), 1));
        var _a = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], t = _a[0], step = _a[1];
        return t.every(step);
    }
    return [ticks, tickInterval];
}
var _a = ticker(utcYear, utcMonth, utcWeek, utcDay, utcHour, utcMinute), utcTicks = _a[0], utcTickInterval = _a[1];
var _b = ticker(year, month, week, day, hour, minute), timeTicks = _b[0], timeTickInterval = _b[1];
export { utcTicks, utcTickInterval, timeTicks, timeTickInterval };
